import React from 'react'
import { UserRepository } from 'app/shared/data-access/users'
import { useToastContext } from 'app/shared/state/toast-context'
import ForgotPasswordView from './forgot-password-view'
import { useIsBusyContext } from 'app/shared/state/is-busy-context'

/**
 *
 *
 * @return {*}
 */
const ForgotPassword = () => {
  const { addToast, toastOnError } = useToastContext()
  const { isBusy, setIsBusy } = useIsBusyContext()

  const onSendForgotPassword = async (email: string) => {
    setIsBusy(true)
    var result = toastOnError(await UserRepository.sendForgotPasswordEmail(email))

    if (!result.error) {
      addToast({
        variant: `success`,
        message: `De instructies om uw wachtwoord te resetten zijn verstuurd naar ${email}`,
      })
    }
    setIsBusy(false)
  }

  return <ForgotPasswordView onSendForgotPassword={onSendForgotPassword} isBusy={isBusy} />
}

export default ForgotPassword
